<script setup lang="ts">
import InvestmentAmountSelect from '../investmentAmount/investmentAmountSelect.vue'
import IncentivesSelect from '../incentives/IncentivesSelect.vue'
import InterestPaymentTypeSelect from '../interestPayment/InterestPaymentTypeSelect.vue'
import { getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { onMounted } from 'vue'
import { trackAnalyticsInvestmentProcessStep1 } from '../../../utilities/useTracking'

onMounted(() => {
    trackAnalyticsInvestmentProcessStep1()
})
</script>

<template>
    <div class="px-6 py-6">
        <InterestPaymentTypeSelect
            v-if="getCampaignData().asset_data.needs_contract_type_selection"></InterestPaymentTypeSelect>
        <div
            v-if="getCampaignData().asset_data.needs_contract_type_selection"
            class="my-5 border border-t-gray-200"></div>
        <InvestmentAmountSelect></InvestmentAmountSelect>
        <IncentivesSelect v-if="getCampaignData().assets_incentives.length > 0"></IncentivesSelect>
    </div>
</template>

<style scoped></style>
